import i18n from "@/langs/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "Myopia",
      text: `${i18n.t("option.visionType.Myopia")}`,
    },
    {
      value: 1,
      name: "Hyperopia",
      text: `${i18n.t("option.visionType.Hyperopia")}`,
    },
    {
      value: 2,
      name: "Contacts",
      text: `${i18n.t("option.visionType.Contacts")}`,
    },
    {
      value: 3,
      name: "Other",
      text: `${i18n.t("option.visionType.Other")}`,
    },
    {
      value: 4,
      name: "Multifocal",
      text: `${i18n.t("option.visionType.Multifocal")}`,
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
